import type { MedidasPagina } from '@miolos/core';

/**
 * Marcas de corte, quando a folha tem sangria.
 *
 * Cada marca é uma cruz pequena centrada na **linha do corte** — o limite da
 * folha aparada, que fica a sangria para dentro da borda do arquivo. Metade do
 * braço cai no papel que sobra, metade no que fica: é por elas que a guilhotina
 * se guia.
 *
 * Desenhadas em preto de gráfica, por cima de tudo e fora do conteúdo.
 */
export function MarcasDeCorte({ medidas }: { medidas: MedidasPagina }) {
  const sangria = medidas.sangriaMm;
  if (sangria <= 0) return null;

  /** Braço de cada marca, em milímetros (metade para cada lado do corte). */
  const bracoMm = 3;
  const espessuraMm = 0.2;
  const cor = '#111111';

  const cortes = [
    { x: sangria, y: sangria },
    { x: medidas.larguraMm - sangria, y: sangria },
    { x: sangria, y: medidas.alturaMm - sangria },
    { x: medidas.larguraMm - sangria, y: medidas.alturaMm - sangria },
  ];

  return (
    <>
      {cortes.map((corte, indice) => (
        <span key={indice} aria-hidden style={{ position: 'absolute', inset: 0, pointerEvents: 'none' }}>
          <span
            style={{
              position: 'absolute',
              left: `${corte.x - bracoMm / 2}mm`,
              top: `${corte.y - espessuraMm / 2}mm`,
              width: `${bracoMm}mm`,
              height: `${espessuraMm}mm`,
              background: cor,
            }}
          />
          <span
            style={{
              position: 'absolute',
              left: `${corte.x - espessuraMm / 2}mm`,
              top: `${corte.y - bracoMm / 2}mm`,
              width: `${espessuraMm}mm`,
              height: `${bracoMm}mm`,
              background: cor,
            }}
          />
        </span>
      ))}
    </>
  );
}
